import { Canvg } from 'canvg';

const convertSvgToPngBase64 = async (svgString: string): Promise<string> => {
  const canvas = document.createElement('canvas');
  canvas.width = 150;
  canvas.height = 150;

  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Unable to get canvas context');
  }

  const v = await Canvg.from(ctx, svgString);
  await v.render();

  return canvas.toDataURL('image/png').replace(/^data:image\/[a-z]+;base64,/, '');
};

export default convertSvgToPngBase64;
